// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2sVpH","productName":"Table_productName__PlpKC"};